import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileGuard } from '@guards/profile/profile.guard';
import { DocumentCreateComponent } from './document-create/document-create.component';
import { DocumentDetailComponent } from './document-detail/document-detail.component';

const documentsRoutes: Routes = [
  {
    path: 'documents',
    title: 'documents.label',
    children: [
      {
        path: 'new',
        title: 'documents.add',
        component: DocumentCreateComponent,
        canActivate: [ProfileGuard],
        data: { action: 'documents.create' }
      },
      {
        path: ':id',
        title: ':id',
        component: DocumentDetailComponent,
        canActivate: [ProfileGuard],
        data: { action: 'documents.detail', preloader: 'secondary' }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(documentsRoutes)],
  exports: [RouterModule]
})
export class DocumentsRoutingModule {}
